import React from "react";
import { bool, object, string } from "prop-types";
import { connect } from "react-redux";
import { clamp, get } from "lodash";

import More from "../../../atoms/More";
import NewsWithImage from "../../../molecules/NewsWithImage";
import NewsHeadline from "../../../atoms/NewsHeadline";
import ComponentContainer from "../../../layouts/component-container";

import { staticTexts } from "../../../utils/Translate";

import "./organism1.m.css";

const Organism1 = ({ collection, hideLoadMoreButton, lang, hasParentCollection, theme = "", className = "" }) => {
  const { items = [], "associated-metadata": { number_of_stories_to_show: numberOfStories = 3 } = {} } = collection;

  const stories = items.filter(({ type }) => type === "story");

  if (!stories.length) return null;

  const [firstStory, ...otherStory] = stories.slice(0, clamp(numberOfStories, 10));

  const showLoaMore = !hideLoadMoreButton && stories.length >= numberOfStories;

  const renderListStories = otherStory.map(({ story }, index) => (
    <div styleName={`list-story ${showLoaMore ? "" : "none-border"}`} key={index}>
      <NewsHeadline key={index} story={story} cssStyleName="mediumSize" />
    </div>
  ));

  return (
    <div className={`${className} ${theme}`} styleName={`wrapper ${theme !== "default" ? "other-themes" : "default"}`}>
      <ComponentContainer
        styleName={`base ${hasParentCollection ? "parrent-collection" : ""}`}
        className="collection-wrapper"
        collection={collection}
        isBanner={true}
        isDesktopBanner={false}
        childContainer={true}
        disableArrow={hasParentCollection}
        border={!hasParentCollection}
      >
        <div styleName="container">
          <div>
            <NewsWithImage
              story={firstStory?.story}
              styleName="image-story"
              cssStyleName="mediumSize"
              showPublishedAt={false}
              widths={[405, 255, 420]}
            />
            {renderListStories}
          </div>

          {showLoaMore && (
            <div styleName="read-more-button">
              <More type="read-more" collection={collection} text={staticTexts(lang).loadMore} />
            </div>
          )}
        </div>
      </ComponentContainer>
    </div>
  );
};

Organism1.propTypes = {
  collection: object,
  hideLoadMoreButton: bool,
  lang: string,
  theme: string,
  className: string,
  hasParentCollection: bool,
};

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
});

export default connect(mapStateToProps)(Organism1);
